import React from "react"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import {
    maybeSelectedSuiteCategory,
    useSuiteCategoriesReadModel,
} from "../../app-core/v3/_common/machines/suite-categories-machine"
import SuiteModal from "../SuiteModal/SuiteModal"
import { SuiteModalProps } from "./AppModal"

type SuiteProps = {
    modalState: SuiteModalProps
}

const AppSuiteModal: React.FC<React.PropsWithChildren<SuiteProps>> = ({ modalState }) => {
    const [state] = useECommerceMachine()
    const [stateSCRM] = useSuiteCategoriesReadModel(state)
    const { locale, sanityContent } = state.context

    const { suiteCategory, shipVersionKey } = modalState
    const { price } = suiteCategory
    const isSelected = F.pipe(
        maybeSelectedSuiteCategory(stateSCRM),
        O.map((x) => x.price.suiteCategory == price.suiteCategory),
        O.getOrElse(F.constFalse),
    )

    return (
        <SuiteModal
            locale={locale}
            shipId={sanityContent.cruiseData.ship._id}
            shipVersionKey={shipVersionKey}
            suitePrice={price}
            isSelected={isSelected}
            SuiteModalSelectButton={state.context.flowVersion.ui.suiteCategory.SuiteModalButton}
        />
    )
}

export default AppSuiteModal
